module.exports = __webpack_public_path__ + "img/AirtimeIcon.707e8305.png";